export default __webpack_public_path__ + "static/media/imprecisão.409e2568.svg";